import { graphql } from 'react-relay';
export const NativeCollabQuery = graphql`
	query NativeCollabQuery($contentId: ID, $draftShareId: String, $status: [String]) {
		content(id: $contentId, draftShareId: $draftShareId, status: $status) {
			nodes {
				id
				type
				status
				version {
					number
					ncsStepVersion
					by {
						type
						... on KnownUser {
							accountId
						}
					}
				}
				history {
					createdBy {
						displayName
					}
					createdDate
				}
				space {
					id
					name
					homepageId
				}
				labels {
					nodes {
						id
						name
					}
				}
				subType
			}
		}
	}
`;
